import * as React from 'react';
import {IStateProps} from './model';
import {View} from 'react-native';
import {useStyles} from '../../../../hooks/styles';
import {Text} from '../../../text';

export default ({content, style, textStyle}: IStateProps) => {
  const styles = useStyles(({theme}) => ({
    text: {
      ...theme.fonts.body,
      color: theme.footer.textColor,
    },
  }));
  return (
    <View style={style}>
      <Text testID='footer-copyright-text-id' style={[styles.text, textStyle]}>
        {content.footer.copyright}
      </Text>
    </View>
  );
};
